import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Typography } from '@mui/material';
import AmountInput from './AmountInput';

export default class BalancesEditor extends React.Component {
    handleChange = (currency, value) => {
        const updatedBalances = {
            ...this.props.balances,
            [currency]: value || 0
        };
        this.props.onChange(updatedBalances);
    };

    render() {
        const { balances, label, readOnly } = this.props;

        if (readOnly) {
            return (
                <Box marginBottom={2}>
                    {label && (
                        <Typography variant="subtitle2">{label}</Typography>
                    )}
                    <Grid container spacing={2}>
                        {Object.entries(balances).map(([currency, amount]) => (
                            <Grid item xs={6} sm={4} key={currency}>
                                <Typography variant="body2">
                                    {currency}: {amount}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            );
        }

        return (
            <Box marginBottom={2}>
                {label && (
                    <Typography variant="subtitle2" marginBottom={1}>
                        {label}
                    </Typography>
                )}
                <Grid container spacing={2}>
                    {Object.entries(balances).map(([currency, amount]) => (
                        <Grid item xs={6} sm={4} key={currency}>
                            <AmountInput
                                id={currency}
                                label={currency}
                                value={amount}
                                onChange={(id, value) =>
                                    this.handleChange(id, value)
                                }
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        );
    }
}

BalancesEditor.propTypes = {
    balances: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    readOnly: PropTypes.bool
};

BalancesEditor.defaultProps = {
    label: null,
    readOnly: false
};
